// extracted by mini-css-extract-plugin
export default {"descritonText":"F76gCml0vZExExYKxnpn"};